<template>
    <layout-gestao>
        <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="saveItem" @submit.prevent="">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-family_id"
                                    name="family_id"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.families"
                                    v-model.trim="form.family_id"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('family_id') }]"
                                    :error=" fnFirstError('family_id')">
                                    {{ $t(`${pageID}.model.family`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem || kinds.length == 0"
                                    class="city-form-group city-bg"
                                    id="input-kind_id"
                                    name="kind_id"
                                    label="name"
                                    :filterable="true"
                                    :options="kinds"
                                    v-model.trim="form.kind_id"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('kind_id') }]"
                                    :error=" fnFirstError('kind_id')">
                                    {{ $t(`${pageID}.model.kind`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-10">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-name"
                                    name="name"
                                    v-model.trim="form.name"
                                    v-validate="'required|min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('name') }]"
                                    :error=" fnFirstError('name')">
                                    {{ $t(`${pageID}.model.name`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="number"
                                    class="city-form-group city-bg"
                                    id="input-order"
                                    name="order"
                                    v-model.trim="form.order"
                                    v-validate="'required|integer|min_value:1'"
                                    :inputClasses="[{'is-invalid':
                                    fnHasError('order') }]"
                                    :error=" fnFirstError('order')">
                                    {{ $t(`${pageID}.model.order`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="" :class="[enableEdocLink ? 'col-sm-4' : 'col-sm-6']">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-code"
                                    name="code"
                                    v-model.trim="form.code"
                                    v-validate="'max:15'"
                                    :inputClasses="[{'is-invalid': fnHasError('code') }]"
                                    :error=" fnFirstError('code')">
                                    {{ $t(`${pageID}.model.code`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="" :class="[enableEdocLink ? 'col-sm-4' : 'col-sm-6']">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-code_anepc"
                                    name="code_anepc"
                                    v-model.trim="form.code_anepc"
                                    v-validate="'max:15'"
                                    :inputClasses="[{'is-invalid': fnHasError('code_anepc') }]"
                                    :error=" fnFirstError('code_anepc')">
                                    {{ $t(`${pageID}.model.code_anepc`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-4" v-if="enableEdocLink">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-code_edoclink"
                                    name="code_edoclink"
                                    v-model.trim="form.code_edoclink"
                                    v-validate="'max:15'"
                                    :inputClasses="[{'is-invalid': fnHasError('code_edoclink') }]"
                                    :error=" fnFirstError('code_edoclink')">
                                    {{ $t(`${pageID}.model.code_edoclink`) }}
                                </MaterialInput>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group city-form-group city-bg">
                                <MaterialTextarea
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-description"
                                    name="description"
                                    v-model.trim="form.description"
                                    v-validate="'emojis|min:10'"
                                    :inputClasses="[{'is-invalid': fnHasError('description') }]"
                                    :error="fnFirstError('description')">
                                    {{ $t(`${pageID}.model.description`) }}
                                </MaterialTextarea>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin'

    export default {
        mixins: [mixin],
        data() {
            return {
                pageID: 'types',
                form: {
                    id: null,
                    name: null,
                    description: null,
                    code: null,
                    code_anepc: null,
                    code_edoclink: null,
                    family_id: null,
                    family: null,
                    kind_id: null,
                    kind: null,
                    order: 1,
                },
                lists: {
                    families: [],
                    unities: [],
                    loaded: false
                }
            }
        },
        mounted(){
            this.loadLists();
        },
        computed: {
            kinds() {
                if(this.form.family_id) {
                    let family = this.lists.families.find(item => item.id == this.form.family_id);
                    if(family) {
                        return family.kinds || [];
                    }
                }
                return []
            },
            kind() {
                return this.kinds.find(k => k.id == this.form.kind_id);
            },
            enableEdocLink() {
                return !!this.panel.enableEdocLink;
            },
        },
        methods: {
            async loadLists() {
                if (!this.lists.loaded && this.url.getLists) {
                    await this.$http.get(this.url.getLists)
                    .then(res => {
                        let data = res.data ? res.data : res;
                        Object.keys(data).forEach(key => {
                            if(key in this.lists) {
                                this.lists[key] = data[key];
                            }
                        });
                        this.lists.loaded = true;
                    })
                    .catch(error =>
                    {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                    })
                }
            },
        },
        watch: {
            'form.family_id': {
                handler(value, oldValue) {
                    if(oldValue && value != oldValue && !this.kind) {
                        this.form.kind_id = null;
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">

</style>

